module.exports = __webpack_public_path__ + "static/media/16_li.40b5c052.png";